import Tool, { type ToolArgs } from '../../../tools/Tool';
import { unwrapLink } from '../utils';
import type { Placement } from '@floating-ui/dom';

// Unlink a hyperlink.
class ToolUnlink extends Tool {
  static toolName = 'Unlink';
  static iconClass = 'fa-regular fa-link-horizontal-slash';

  static action({ editor, element }: ToolArgs): void {
    if (!editor) return;
    if (!editor.selection) return;

    unwrapLink(editor);
  }

  static tooltipPlacement(): Placement {
    return 'bottom';
  }
}

export default ToolUnlink;
